<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col md="12">
        <h4 style="text-align: center">2. DOMICILIO DEL DECLARANTE</h4>
      </b-col>

      <b-col md="12">
        <b-form-group label="LUGAR DONDE RESIDE:">
          <b-form-radio-group
            :disabled="status === 'Concluida'"
            @change="cambios=false, llenaEspacios()"
            v-model="banderaNacionalidad" >
            <b-form-radio value="Mexico">MÉXICO</b-form-radio>
            <b-form-radio value="Extranjero">EXTRANJERO</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="mexicano">
      <b-col md="6">
        <b-form-group>
          <label>CALLE</label>
          <b-form-input
            :disabled="status === 'Concluida'"
            v-model="domicilio.domicilioMexico.calle"
            placeholder="CALLE"
            @change="cambios = true"
            :class="{invalid_input: $v.domicilio.domicilioMexico.calle.$error}"
          ></b-form-input>
          <label v-if="$v.domicilio.domicilioMexico.calle.$error && !$v.domicilio.domicilioMexico.calle.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>NÚMERO EXTERIOR</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            v-model="domicilio.domicilioMexico.numeroExterior"
            placeholder="NÚMERO EXTERIOR"
            :class="{invalid_input: $v.domicilio.domicilioMexico.numeroExterior.$error}"           
          ></b-form-input>
          <label v-if="$v.domicilio.domicilioMexico.numeroExterior.$error && !$v.domicilio.domicilioMexico.numeroExterior.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>NÚMERO INTERIOR</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            v-model="domicilio.domicilioMexico.numeroInterior"
            placeholder="NÚMERO INTERIOR"
          ></b-form-input>
        </b-form-group>
      </b-col> 
      <b-col md="3">
        <b-form-group>
          <label>ENTIDAD FEDERATIVA</label>
          <b-form-select
            :disabled="status === 'Concluida'"
            v-model="estadoClave"
            :options="estados"
            text-field="valor"
            value-field="clave"
            @change="cambios=true"
          > </b-form-select>
        </b-form-group>
      </b-col>
       <b-col md="3">
        <b-form-group>
          <label>MUNICIPIO / ALCALDIA</label>
          <b-form-select
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            :options="cargaMunicipio"
            v-model="muniClave"
            text-field="valor"
            value-field="clave"
          > </b-form-select>
        </b-form-group>
      </b-col>
       <b-col md="3">
        <b-form-group>
          <label>COLONIA / LOCALIDAD</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioMexico.coloniaLocalidad"
            placeholder="COLONIA / LOCALIDAD"
            :class="{invalid_input: $v.domicilio.domicilioMexico.coloniaLocalidad.$error}"           
          ></b-form-input>
          <label v-if="$v.domicilio.domicilioMexico.coloniaLocalidad.$error && !$v.domicilio.domicilioMexico.coloniaLocalidad.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>

     
      <b-col md="3">
        <b-form-group>
          <label>CÓDIGO POSTAL</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioMexico.codigoPostal"
            placeholder="CÓDIGO POSTAL"
            :class="{invalid_input: $v.domicilio.domicilioMexico.codigoPostal.$error}"           
          ></b-form-input>
          <label v-if="$v.domicilio.domicilioMexico.codigoPostal.$error && !$v.domicilio.domicilioMexico.codigoPostal.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="2">
        <b-form-group>
          <label>País:</label>
          <b-form-select
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            v-model="clavesPais"
            :options="pais"
            text-field="nombre"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label>Calle:</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioExtranjero.calle"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Número exterior:</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioExtranjero.numeroExterior"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Número interior:</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioExtranjero.numeroInterior"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label>Ciudad:</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioExtranjero.ciudadLocalidad"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label>Estado/Provincia:</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioExtranjero.estadoProvincia"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label>Código postal:</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.domicilioExtranjero.codigoPostal"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
             :disabled="status === 'Concluida'"
            @change="cambios=true"
            type="text"
            v-model="domicilio.aclaracionesObservaciones"
            placeholder="ACLARACIONES / OBSERVACIONES"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col >
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando">Regresar al índice</b-button>
      </b-col>

      <b-col>
        <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
      </b-col> 
      <b-col >
        <b-button variant="secondary" @click="verSeccion(1)" :disabled="enviando">Anterior</b-button>
        <b-button
          class="pull-right"
          variant="primary"
          @click="actualizarSeccion()"
          :disabled="enviando"
        >Siguiente</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { muni } from "../../../store/municipios";
import { paises } from "../../../store/paises";
import { required } from "vuelidate/lib/validators";
export default {
  components: { Loader },
  name:"domicilio",
  props: ["domicilio", 'status'],
  watch:{
    'estadoClave':function(val){
      let index = this.estados.findIndex(x=>x.clave==val)
      if(index!==-1)this.estadoNombre=this.estados[index].valor;
    },
    'muniClave':function(val){
      let index = this.cargaMunicipio.findIndex(x=>x.clave==val)
      if(index!==-1)this.muniNombre=this.cargaMunicipio[index].valor;
    }

  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),

    mexicano() {
      if (this.banderaNacionalidad === "Mexico")   return true;
      else return false;
    },
    cargaMunicipio() {
      let listaMuni = [];

      if (this.estadoClave !== null) {
        this.municipios.forEach(value => {
          if (value.claveEstado === this.estadoClave) {
            listaMuni.push(value);
            //console.log(value);
          }
          
        });
      }
      return listaMuni.sort();
    }
  },
  validations:{
    domicilio: {
      domicilioMexico:{
      calle:{required} ,
      numeroExterior:{required},
      coloniaLocalidad:{required},
      codigoPostal:{required}
        }
    },

  },


  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
   
      banderaNacionalidad: "Mexico",
      estadoNombre: " ",
      estadoClave: " ",
      muniNombre: null,
      muniClave: null,
      clavesPais: "",
      municipios: muni,
      pais: paises
    };
  },

  methods: {
    actualizarSeccion() {
      let formValido=false;
     if(this.mexicano){
       this.$v.$touch();  
       if (!this.$v.$invalid) formValido=true
     }else formValido=true
     if(formValido){
      this.enviando = true;
      axios
        .put(this.httpURL +"/declaraciones/V2/domicilioDeclarante/" +this.$route.params.id,
          {
            MXcalle: this.domicilio.domicilioMexico.calle,
            MXnumeroExterior: this.domicilio.domicilioMexico.numeroExterior,
            MXnumeroInterior: this.domicilio.domicilioMexico.numeroInterior,
            MXcoloniaLocalidad: this.domicilio.domicilioMexico.coloniaLocalidad,
            MXmunicipioAlcaldiaClave: this.muniClave,
            MXmunicipioAlcaldiaValor: this.muniNombre,
            MXentidadFederativaClave: this.estadoClave,
            MXentidadFederativaValor: this.estadoNombre,
            MXcodigoPostal: this.domicilio.domicilioMexico.codigoPostal,
            EXTcalle: this.domicilio.domicilioExtranjero.calle,
            EXTnumeroExterior: this.domicilio.domicilioExtranjero
              .numeroExterior,
            EXTnumeroInterior: this.domicilio.domicilioExtranjero
              .numeroInterior,
            EXTciudadLocalidad: this.domicilio.domicilioExtranjero
              .ciudadLocalidad,
            EXTestadoProvincia: this.domicilio.domicilioExtranjero
              .estadoProvincia,
            EXTpais: this.clavesPais,
            EXTcodigoPostal: this.domicilio.domicilioExtranjero.codigoPostal,
            aclaracionesObservaciones: this.domicilio.aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          this.enviando = false;
          this.cambios = false;
          this.verSeccion(3)
          this.$notify({group: "foo",type: "success", duration: 2500, speed: 1000,text: res.data.mensaje});
        })
        .catch(error => {
           this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: "No se pudo guardar la sección" });
          this.enviando = false;
        });
      }
      
      
    },

    llenaEspacios() {
      if (this.banderaNacionalidad !== "México") {
        this.domicilio.domicilioExtranjero.calle = "";
        this.domicilio.domicilioExtranjero.numeroExterior = "";
        this.domicilio.domicilioExtranjero.numeroInterior = "";
        this.domicilio.domicilioExtranjero.ciudadLocalidad = "";
        this.domicilio.domicilioExtranjero.estadoProvincia = "";
        this.clavesPais = "";
        this.domicilio.domicilioExtranjero.codigoPostal = "";
      } else {
        this.domicilio.domicilioMexico.calle = "";
        this.domicilio.domicilioMexico.numeroExterior = "";
        this.domicilio.domicilioMexico.numeroInterior = "";
        this.domicilio.domicilioMexico.coloniaLocalidad = "";
        this.muniClave = "";
        this.muniNombre = "";
        this.estadoClave = "";
        this.estadoNombre = "";
        this.domicilio.domicilioMexico.codigoPostal = "";
      }
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    }
 
  },

  created() {
    this.clavesPais = this.domicilio.domicilioExtranjero.pais;
    this.estadoClave = this.domicilio.domicilioMexico.entidadFederativa.clave?this.domicilio.domicilioMexico.entidadFederativa.clave:this.estados[0].clave;
    this.muniClave = this.domicilio.domicilioMexico.municipioAlcaldia.clave ? this.domicilio.domicilioMexico.municipioAlcaldia.clave : this.cargaMunicipio[0].clave;
    if (this.clavesPais !== "") {
      this.banderaNacionalidad = "Mexico";
    }

  }
};
</script>


<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>
